
import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderNewFlowRoundingItemsModalStore } from 'application/facility-order-new-flow-order-summary/stores';
import { FacilityOrderNewFlowRoundingItemsModalTemplate } from 'themes/application/facility-order-new-flow-order-summary/components';

@setCurrentView((rootStore, componentProps) => new FacilityOrderNewFlowRoundingItemsModalStore(rootStore, componentProps), 'facilityOrderNewFlowRoundingItemsModalStore')
@observer
class FacilityOrderNewFlowRoundingItemsModal extends React.Component {
    render() {
        return <FacilityOrderNewFlowRoundingItemsModalTemplate {...this.props} />
    }
}

export default FacilityOrderNewFlowRoundingItemsModal;
